import { render, staticRenderFns } from "./ConfigRoleList.vue?vue&type=template&id=dd1feade&scoped=true&"
import script from "./ConfigRoleList.vue?vue&type=script&lang=js&"
export * from "./ConfigRoleList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigRoleList.vue?vue&type=style&index=0&id=dd1feade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1feade",
  null
  
)

export default component.exports